export default {
  nav: {
    spreadsheet: 'Regneark',
    categories: 'Kategorier',
    products: 'Produkter',
    guides: 'Guides',
    reviews: 'Anmeldelser',
    shipping: 'Forsendelse',
    safety: 'Sikkerhed',
    comparisons: 'Sammenligninger',
    faq: 'FAQ',
    mainSite: 'Hovedside',
  },
  languages: {
    en: 'English',
    fr: 'Français',
    da: 'Dansk',
    de: 'Deutsch',
  },
  hero: {
    h1: 'AllChinaBuy Spreadsheet — Find Produkter, Sælgere & Købsressourcer',
    subtitle: 'Udforsk AllChinaBuy-regnearket, produktlister, sælgerressourcer, QC-guides, forsendelsesinformation og praktiske købstips — alt organiseret i én brugervenlig ressourcehub.',
    ctaPrimary: 'Udforsk AllChinaBuy Spreadsheet',
    ctaSecondary: 'Besøg Hovedside',
    searchPlaceholder: 'Søg AllChinaBuy-regneark, produkter, sælgere eller guides…',
    trust: 'Uafhængig Ressource • Regelmæssigt Opdateret • Begyndervenlig',
  },
  categories: {
    title: 'Populære Kategorier',
    subtitle: 'Gennemse produkter efter kategori og opdag de bedste varer tilgængelige via AllChinaBuy',
    viewAll: 'Se Alle Kategorier',
  },
  dropdown: {
    label: 'Vælg en Kategori',
    placeholder: 'Vælg en produktkategori...',
    goButton: 'Gå til Kategori',
  },
  ctas: {
    exploreTitle: 'AllChinaBuy Spreadsheet',
    exploreDesc: 'Få adgang til det komplette produkt- og sælgerregneark med udvalgte links og opdateret information.',
    exploreButton: 'AllChinaBuy Spreadsheet',
    buyTitle: 'Køb Det Nu',
    buyDesc: 'Spring research over og gå direkte til hovedsiden for at begynde at handle med det samme.',
    buyButton: 'Køb Det Nu',
  },
  spreadsheet: {
    title: 'Regneark Explorer',
    subtitle: 'Naviger i AllChinaBuy-regnearket med lethed. Find produkter, sælgere og ressourcer organiseret til hurtig adgang.',
    feature1: 'Udvalgte Produktlinks',
    feature2: 'Verificeret Sælgerkatalog',
    feature3: 'Regelmæssigt Opdateret',
    feature4: 'Begyndervenlig',
  },
  featured: {
    title: 'Udvalgte Produkter',
    subtitle: 'Opdag populære varer fra AllChinaBuy-regnearksfællesskabet',
  },
  guides: {
    title: 'Seneste Guides',
    subtitle: 'Trin-for-trin guides til at hjælpe dig med at undersøge, købe og sende produkter sikkert',
    readMore: 'Læs Guide',
    guide1Title: 'Komplet Guide til AllChinaBuy Spreadsheet',
    guide1Desc: 'Lær alt om effektiv brug af AllChinaBuy-regnearket til produktresearch.',
    guide2Title: 'Sådan Finder Du Pålidelige Sælgere',
    guide2Desc: 'Vigtige tip til evaluering af sælgerreputation og undgåelse af almindelige faldgruber.',
    guide3Title: 'Forsendelses- & Lager Guide',
    guide3Desc: 'Sammenlign forsendelsesmetoder, beregn omkostninger og vælg den bedste leveringsmulighed.',
    guide4Title: 'AllChinaBuy Anmeldelse 2026',
    guide4Desc: 'Ærlig og opdateret anmeldelse af AllChinaBuy-platformen, funktioner og brugeroplevelse.',
  },
  trust: {
    title: 'Hvorfor Stole på Denne Ressource?',
    independent: 'Uafhængig Platform',
    independentDesc: 'Vi er ikke tilknyttet AllChinaBuy. Vores mål er at give ærlig, hjælpsom information.',
    updated: 'Regelmæssigt Opdateret',
    updatedDesc: 'Indhold gennemgås og opdateres for at afspejle de seneste platformændringer og forsendelsespriser.',
    beginner: 'Begyndervenlig',
    beginnerDesc: 'Klare forklaringer og trin-for-trin guides gør det nemt for nye brugere at komme i gang.',
  },
  searchCards: {
    title: 'Populære Søgninger',
    spreadsheet: 'AllChinaBuy Spreadsheet',
    review: 'AllChinaBuy Anmeldelse',
    shipping: 'AllChinaBuy Forsendelsesomkostning',
    coupon: 'AllChinaBuy Kupon',
    discount: 'AllChinaBuy Rabatkode',
    warehouse: 'AllChinaBuy Lager',
    legit: 'AllChinaBuy Legitim',
    qc: 'AllChinaBuy QC',
  },
  finalCta: {
    title: 'Klar til at Udforske Flere Produkter?',
    subtitle: 'Brug vores guides til at researche først, og fortsæt derefter til hovedsiden for at udforske flere produkter.',
    button: 'Fortsæt til Hovedside',
  },
  footer: {
    about: 'Om',
    contact: 'Kontakt',
    editorial: 'Redaktionel Politik',
    privacy: 'Privatliv',
    terms: 'Vilkår',
    disclaimer: 'Ansvarsfraskrivelse',
    affiliate: 'Partnerannoncering',
    description: 'Et uafhængigt ressourcehub for AllChinaBuy-regnearkbrugere. Vi hjælper købere med at undersøge produkter, sælgere og forsendelsesmuligheder før køb.',
    copyright: 'Alle rettigheder forbeholdes.',
    notAffiliated: 'Dette website er en uafhængig informativ ressource og er ikke det officielle AllChinaBuy-website.',
  },
  breadcrumb: {
    home: 'Hjem',
  },
  article: {
    toc: 'Indholdsfortegnelse',
    updated: 'Opdateret',
    author: 'Forfatter',
    readTime: 'min læsning',
    related: 'Relaterede Artikler',
    backToHome: 'Tilbage til Hjem',
  },
  faq: {
    title: 'Ofte Stillede Spørgsmål',
    q1: 'Hvad er AllChinaBuy-regnearket?',
    a1: 'AllChinaBuy-regnearket er en kurateret samling af produktlinks, sælgerinformation og købsressourcer organiseret til at hjælpe købere med effektivt at finde varer via AllChinaBuy-platformen.',
    q2: 'Er AllChinaBuy legitim?',
    a2: 'AllChinaBuy er en legitim indkøbsagent-platform. Som ved ethvert onlinekøb bør købere dog researche sælgere, kontrollere QC-fotos og forstå forsendelsesomkostninger før bestilling.',
    q3: 'Hvordan bruger jeg AllChinaBuy-regnearket?',
    a3: 'Gennemse regnearket efter kategori, klik på produktlinks for at se detaljer, sammenlign sælgere og brug de leverede links til at navigere til AllChinaBuy-platformen til køb.',
    q4: 'Hvilke forsendelsesmetoder tilbyder AllChinaBuy?',
    a4: 'AllChinaBuy tilbyder flere forsendelsesmuligheder inklusive international express, standardforsendelse og lagerkonsolidering. Omkostninger varierer efter destination og pakkevægt.',
  },
  comparison: {
    title: 'Hvordan AllChinaBuy Sammenlignes',
    feature: 'Funktion',
    productDiscovery: 'Produktopdagelse',
    spreadsheetResources: 'Regneark Ressourcer',
    qc: 'QC Fotos',
    warehouse: 'Lageropbevaring',
    shipping: 'Forsendelsesmuligheder',
    payment: 'Betalingsmetoder',
    support: 'Kundesupport',
  },
  safety: {
    title: 'Sikkerhedscenter',
    subtitle: 'Vigtig information til at hjælpe dig med sikkert at handle og undgå almindelige risici',
    payment: 'Betalingssikkerhed',
    paymentDesc: 'Brug sikre betalingsmetoder og del aldrig loginoplysninger direkte med sælgere.',
    verification: 'Sælgervificering',
    verificationDesc: 'Tjek sælgerbedømmelser, anmeldelseshistorik og community-feedback før bestilling.',
    qc: 'QC Sikkerhed',
    qcDesc: 'Anmod altid om og gennemgå QC-fotos før godkendelse af forsendelser fra lageret.',
    scams: 'Almindelige Svindelnumre',
    scamsDesc: 'Lær at identificere mistænkelige links, falske sælgere og almindelige phishing-forsøg.',
  },
};